import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { useDebounce } from 'react-use'
import { cx } from 'src/utils/cx'
import ModelSearchBar from '../GenerationTask/MultiColumnGenerationForm/Common/ModelSearchBar'

type GenerationSelectableDialogSearchWrapperProps = {
  tabVal: string
  searchKeyword: string
  placeholder: string
  onSearchKeywordForInput?: (v: string) => void
  onInputChange: (value: string) => void
  onClear: () => void
} & StyleProps

export const GenerationSelectableDialogSearchWrapper = forwardRef<
  {
    cancelDebounce: () => void
  },
  GenerationSelectableDialogSearchWrapperProps
>(function GenerationSelectableDialogSearchWrapper(props, ref) {
  const {
    tabVal,
    placeholder,
    searchKeyword,
    onInputChange,
    onClear,
    ...rest
  } = props
  const [searchKeywordForInput, setSearchKeywordForInput] =
    useState(searchKeyword)

  const commenceChange = useCallback(
    (v: string) => {
      onInputChange(v)
    },
    [onInputChange],
  )

  const [, cancel] = useDebounce(
    () => {
      commenceChange(searchKeywordForInput)
    },
    1500,
    [tabVal, searchKeywordForInput],
  )

  useImperativeHandle(
    ref,
    () => ({
      cancelDebounce: cancel,
    }),
    [cancel],
  )

  // Effect to commit update immediately on tab changes
  useEffect(() => {
    cancel()
    commenceChange(searchKeywordForInput)
  }, [tabVal])

  return (
    <ModelSearchBar
      {...rest}
      className={cx('flex-auto', props.className)}
      onClear={() => {
        onClear()
        setSearchKeywordForInput('')
        cancel()
      }}
      inputProps={{
        value: searchKeywordForInput,
        onChange: e => setSearchKeywordForInput(e.target.value),
        placeholder,
      }}
    />
  )
})
